import * as THREE from 'three';

// Charge public/textures/icons.<hash>.png + icons.json une fois, au démarrage,
// et le tient à disposition de poster.js. Même forme preload/get que
// soundboard-texture.js, et pour la même raison : un visualiseur ne doit
// jamais aller chercher une texture dans son init(), sans quoi un changement
// de composition montre une image vide le temps du chargement.
//
// Adresses RELATIVES : express.static n'envoie aucun en-tête CORS, et cette
// page tourne aussi depuis l'origine file:// de l'application Tizen.
const MANIFESTE = 'textures/icons.json';

let _atlas = null;
let _promesse = null;

function configurer(texture) {
  // PAS DE MIPMAPS, et c'est important. Les 131 cases sont jointives : un
  // niveau de mipmap mélange une case avec sa voisine, et le champ de
  // distance d'un coeur se met à contenir un bout de voiture. Le filtrage
  // linéaire, lui, est nécessaire - un SDF échantillonné au plus proche
  // redonne des marches d'escalier sur le contour, ce qui est exactement ce
  // que le SDF existe pour éviter. Le shader borne l'échantillonnage à
  // l'intérieur de la case pour que le linéaire ne déborde pas non plus.
  // flipY = false. three.js retourne l'image au chargement ; l'atlas est
  // indexé par (colonne, ligne) depuis le HAUT du PNG, et la ligne 0 se
  // retrouvait donc en bas - on échantillonnait une case vide, le champ valait
  // « très dehors » partout et aucun pictogramme ne se dessinait.
  texture.flipY = false;
  texture.colorSpace = THREE.NoColorSpace;   // un champ de distance, pas une couleur
  texture.wrapS = THREE.ClampToEdgeWrapping;
  texture.wrapT = THREE.ClampToEdgeWrapping;
  texture.generateMipmaps = false;
  texture.minFilter = THREE.LinearFilter;
  texture.magFilter = THREE.LinearFilter;
  texture.needsUpdate = true;
  return texture;
}

function charger(url) {
  return new Promise(function (resolve, reject) {
    new THREE.TextureLoader().load(url, resolve, undefined, function () {
      reject(new Error(url + ' introuvable'));
    });
  });
}

// Résout vers { texture, manifeste } ou vers null. Ne rejette jamais : sans
// atlas, poster.js dessine ses blocs et sa typographie et se passe de
// pictogrammes, ce qui est dégradé mais pas cassé.
export function preloadIconAtlas() {
  if (_promesse) return _promesse;
  _promesse = fetch(MANIFESTE)
    .then(function (r) { if (!r.ok) throw new Error(MANIFESTE + ' ' + r.status); return r.json(); })
    .then(function (m) {
      return charger('textures/' + m.fichier).then(function (t) {
        _atlas = { texture: configurer(t), manifeste: m };
        return _atlas;
      });
    })
    .catch(function (e) {
      console.warn('[icon-atlas] ' + e.message + ' - poster.js tournera sans pictogrammes.');
      _atlas = null;
      return null;
    });
  return _promesse;
}

export function getIconAtlas() { return _atlas; }
